/* eslint-disable @typescript-eslint/no-explicit-any */
// Löst Pointer wie "#/path/to/def" relativ zum root-Schema auf
const resolvePointer = (pointer: string, root: any): any => {
  const parts = pointer.replace(/^#\//, '').split('/')
  let cur: any = root
  for (const part of parts) {
    if (cur && typeof cur === 'object' && part in cur) {
      cur = cur[part]
    } else {
      console.warn(
        `[Jsonparser] Pfad ${pointer} nicht gefunden bei Teil "${part}"`
      )
      return undefined
    }
  }
  return cur
}

// Dereferenzierungs-Funktion
const deref = (schema: any): any => {
  const cache = new Map<any, any>()

  const recurse = (obj: any, root: any, path = ''): any => {
    if (obj && typeof obj === 'object') {
      // Gefundener $ref
      if (
        obj.$ref &&
        typeof obj.$ref === 'string' &&
        obj.$ref.startsWith('#/')
      ) {
        const target = resolvePointer(obj.$ref, root)
        if (!target) {
          console.warn(
            `[Jsonparser] Pointer ${obj.$ref} konnte nicht aufgelöst werden.`
          )
          return { ...obj }
        }
        // Cache-Hit (Zyklus oder mehrfach)
        if (cache.has(target)) {
          const cached = cache.get(target)
          const { ...siblings } = obj
          return Object.keys(siblings).length
            ? { ...cached, ...siblings }
            : cached
        }
        // Zuerst rekursiv dereferenzieren
        const derefTarget = recurse(target, root, path)
        let merged
        if (derefTarget && typeof derefTarget === 'object') {
          const { ...siblings } = obj
          merged = Array.isArray(derefTarget)
            ? derefTarget.map((v) => v)
            : { ...derefTarget, ...siblings }
          cache.set(target, merged)
          return merged
        }
        return derefTarget
      }
      // Array: jedes Element durchlaufen
      if (Array.isArray(obj)) {
        return obj.map((item, i) => recurse(item, root, `${path}[${i}]`))
      }
      // Standard-Objekt: alle Properties durchlaufen
      const out: any = {}
      for (const [k, v] of Object.entries(obj)) {
        out[k] = recurse(v, root, path ? `${path}.${k}` : k)
      }
      return out
    }
    // Primitive oder null
    return obj
  }

  return recurse(schema, schema, '')
}

const Jsonparser = { deref }
export default Jsonparser
